<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" :class="readonly ? 'not-click' : ''" style="width: fit-content">
        <div style="display: flex">
          <template v-for="(upBlocks, index) in upBlocksList">
            <div :key="index" class="section" style="width: 371px;margin-right: 5px;">
              <el-form :disabled="readonly" label-width="140px" label-position="right" style="height: 100%;display: flex;flex-direction: column;">
                <div v-for="(block, subIndex) in upBlocks" :ref="block.pagePart.pagePartName" :key="block.pagePart.pagePartName" :style="subIndex===upBlocks.length-1?'flex-grow: 1':''">
                  <span class="title" style="width: 100%;">
                    {{ block.customLabel || block.sysLabel }}
                    <i class="el-icon-edit" style="margin-left: 5px;" @click="onEditBlockLabel(block)" />
                    <span class="sort-char" style="float: right;" @mousedown="onMousedown($event, block)">≡</span>
                  </span>
                  <el-form-item label=" ">
                    <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                    <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                    <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                    <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
                    <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
                  </el-form-item>
                  <el-form-item v-for="element in block.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
                    <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                    <el-checkbox
                      v-model="element.isDisplay"
                      :disabled="readonly || element.isRequire || !element.branchIsDisplay"
                      class="element-column-content"
                      @change="onDisplayChange(block, element)"
                    />
                    <el-checkbox
                      v-model="element.isRequire"
                      disabled
                      class="element-column-content"
                    />
                    <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                    <template>
                      <template v-if="canSettingElementNames.includes(element.pagePartElement.elementName)">
                        <span v-if="readonly" class="element-column-content">
                          <div v-if="element.userCustomContent" class="look-blue" @click="showElementSettingDialog(element)" />
                          <div v-else class="look-gray" />
                        </span>
                        <span v-else class="element-column-content">
                          <i class="el-icon-edit" @click="showElementSettingDialog(element)" />
                        </span>
                      </template>
                      <span v-else class="element-column-content" />
                    </template>
                    <span :class="'element-column-content sort-char' + (readonly ? ' not-click' : '')" style="line-height: unset;" @mousedown="onMousedown($event, block, element)">≡</span>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </template>
        </div>
        <div v-if="downBlock" :ref="downBlock.pagePart.pagePartName" class="section" style="width: 371px">
          <el-form :disabled="readonly" label-width="140px" label-position="right">
            <span class="title" style="width: 100%;">
              {{ downBlock.customLabel || downBlock.sysLabel }}
              <i class="el-icon-edit" style="margin-left: 5px;" @click="onEditBlockLabel(downBlock)" />
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
            </el-form-item>
            <el-form-item v-for="element in downBlock.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox
                v-model="element.isDisplay"
                :disabled="readonly || element.isRequire || !element.branchIsDisplay"
                class="element-column-content"
                @change="onDisplayChange(downBlock, element)"
              />
              <el-checkbox
                v-model="element.isRequire"
                disabled
                class="element-column-content"
              />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
              <template>
                <template v-if="canSettingElementNames.includes(element.pagePartElement.elementName)">
                  <span v-if="readonly" class="element-column-content">
                    <div v-if="element.userCustomContent" class="look-blue" @click="showElementSettingDialog(element)" />
                    <div v-else class="look-gray" />
                  </span>
                  <span v-else class="element-column-content">
                    <i class="el-icon-edit" @click="showElementSettingDialog(element)" />
                  </span>
                </template>
                <span v-else class="element-column-content" />
              </template>
              <span :class="'element-column-content sort-char' + (readonly ? ' not-click' : '')" style="line-height: unset;" @mousedown="onMousedown($event, downBlock, element)">≡</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 以下复制了一份页面内容，用于拖拽 -->
      <template>
        <div v-for="block in blocks" :ref="'drag' + block.pagePart.pagePartName" :key="block.pagePart.pagePartName" class="section" style="width: 371px;height: 0;overflow: hidden;padding: 0;margin-bottom: 0;">
          <el-form label-width="140px" label-position="right">
            <span class="title" style="width: 100%;">
              {{ block.customLabel || block.sysLabel }}
              <i class="el-icon-edit" style="margin-left: 5px;" />
              <span class="sort-char" style="float: right;">≡</span>
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
            </el-form-item>
            <el-form-item v-for="element in block.uiCustomElementList" :ref="'drag' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="background-color: #f0f3f8;">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox v-model="element.isDisplay" class="element-column-content" />
              <el-checkbox v-model="element.isRequire" class="element-column-content" />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;">{{ element.customLabel }}</span>
              <template>
                <span v-if="canSettingElementNames.includes(element.pagePartElement.elementName)" class="element-column-content">
                  <i class="el-icon-edit" />
                </span>
                <span v-else class="element-column-content" />
              </template>
              <span class="element-column-content sort-char" style="line-height: unset;">≡</span>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <!-- 预览 -->
      <tab-vessel-eq-UICustom v-if="isPreview" :context="bookingWorkspaceContext" action="look" :preview-config="previewConfig" />
    </div>
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" :is-edit="isEdit" />
  </div>
</template>

<script>
import seaBookingVessel from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingVessel'
import ElementSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/ElementSetDialog'

export default {
  name: 'UserSeaBookingVessel',
  components: { ElementSetDialog },
  extends: seaBookingVessel,
  data() {
    return {
      blockWidth: 371,
      canSettingElementNames: [
        'vessel',
        'voyageFlight'
      ], // 可以进行设置的元素名称
      elementSetDialog: {
        visible: false,
        element: {}
      }
    }
  },
  computed: {
    elementRelateBlockPropName() {
      return 'uiCustomElementBlockUserUuid'
    }
  },
  methods: {
    showElementSettingDialog(element) {
      this.elementSetDialog.visible = true
      this.elementSetDialog.element = element
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../pageUICustom/base.scss'
</style>
